/* Important Info component for the Cast Info */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Callsheets.module.css";

const CastInfoManage = () => {

  return (
   <div>
    <Row className="my-3">
    <Col md={{span: 10, offset: 1}}>
    <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
      <p className={`${styles.Red} text-center`}>MANAGE CAST</p>
      <hr className={`mt-2 mb-0`}/>
      <p className={`pt-2`}>
      Cast Info is contained in the Characters Section.
    </p>
      <p className={`pt-3`}>
      <span className={`${styles.Red}`}>*</span> The Actors playing the Character <span className={`${styles.Red}`}>MUST:</span></p>
      <p className={`pt-2`}>
      <span className={`${styles.Red}`}>-</span> Be <span className={`${styles.Red}`}>registered</span> here by clicking the Add User tab.
      </p>
      <p className={`pt-2`}>
      <span className={`${styles.Red}`}>-</span> Be <span className={`${styles.Red}`}>added</span> on the Character Edit page.
    </p>
    <p className={`pt-5`}>
      <span className={`${styles.Red}`}>*</span> The <span className={`${styles.Red}`}>Callname</span> which displays on the Character Edit page must be
      inputted in the Add User form's "Callname" field.
    </p>
    <p className={`pt-2`}>
       <span className={`${styles.Red}`}>*</span> The Actor's name and email <span className={`${styles.Red}`}>MUST</span> be
      added on the Character Edit page
      in order for them to receive Callsheets.
    </p>
    <p className={`pt-3 ${styles.Small}`}>
    Note: Only Admin & Superadmin Users can add, edit and view the Actor's  
    personal details on their Character’s page.
    </p>
    <p className={`pt-2 ${styles.Small}`}>
      Note: Please ensure the email entered is correct.
    </p>
    <hr className={`mt-2 mb-0`}/>
    </div>  
    </Col>
    </Row>
    </div>
)
}

export default CastInfoManage 